import { QuestionSimpleComponent } from './question-simple.component';

export default angular
  .module('sfMobile.components.question-simple', ['sfMobile.services.pubsub'])
  .component('questionSimple', QuestionSimpleComponent).name;
